<!-- <button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="dialogRef.close(false)">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button> -->

<h1 mat-dialog-title class="text-center blueHeader dialogHeader text-white">{{headerTitle}}</h1>
<mat-dialog-content class="mb-4">
  <div class="mt-3 wid">
    <div class="col-md-12 mb-2">
      <label for="category" class="toPay col-md-3 required">Category</label>
      <select name="category" id="category" class="form-control input-font category inputBox col-md-3"
        [(ngModel)]="category" (change)="categoryChanged()">
        <option value="TABLET">Tablet</option>
        <option value="SYRUP-SUPPLEMENT">Syrup</option>
        <option value="VACCINATION-DEWORMING">Vaccination / Deworming</option>
        <option value="DISPOSABLE">Disposables</option>
        <option value="DROPS">Drops</option>
        <option value="INJECTABLE">Injectables</option>
        <option value="POWDER-SHAMPOO">Powder / Shampoo</option>
        <option value="OINTMENT-SPRAY">Ointment / Spray</option>
        <option value="PRODUCT">Consumables</option>
        <option value="SERVICES">Others</option>
      </select>
      <label for="name" class="payingClinic col-md-3 required">Name</label>
      <ng-select [items]="nameData" bindLabel="name" [addTag]="addName" [multiple]="false" placeholder="Select Item"
        (change)="onNameChange($event)" (clear)="onNameClear($event)" class="col-md-3 d-inline-block pl-0 pr-0"
        [(ngModel)]="name_selected">
      </ng-select>

      <!-- <input type="text" class="form-control input-font name inputBox col-md-3" id="name" [(ngModel)]="name"> -->
    </div>
    <div class="col-md-12 mb-2">
      <label for="qty" class="toPay col-md-3 required" *ngIf="category !== 'SERVICES'">Quantity</label>
      <input type="text" numbersOnly class="form-control input-font qty inputBox col-md-3" id="qty" [(ngModel)]="qty"
        min="0" *ngIf="category !== 'SERVICES'">
      <label for="price" class="toPay col-md-3 required">Selling Price</label>
      <input type="text" numbersOnly class="form-control input-font price inputBox col-md-3" id="price"
        [(ngModel)]="price" min="0">
    </div>
    <div class="col-md-12 mb-2" *ngIf="category !== 'SERVICES'">
      <div class="col-md-3 dates">
        <label for="buyprice" class="toPay"> Buying Price</label>
      </div>
      <div class="col-md-3 dates payDate">
        <input type="text" numbersOnly class="form-control input-font price inputBox" id="buyprice"
          [(ngModel)]="buyPrice" min="0">
      </div>
      <div class="col-md-3 dates">
        <label for="expiry_date" class="toPay">Exp Date</label>
      </div>
      <div class="col-md-3 dates payDate">
        <my-date-picker name="nextVaccination" [options]="myDatePickerOptionsExp" class="datePicker" id="expiry_date"
          (dateChanged)="onNextDateChanged($event)">
        </my-date-picker>
        <!-- <input type="text" numbersOnly class="form-control input-font qty inputBox col-md-6" id="qty" [(ngModel)]="expDate"> -->
      </div>
    </div>
    <div class="col-md-12 mb-2" *ngIf="category !== 'SERVICES'">
      <label for="manufacturer" class="toPay col-md-3">Manufacturer</label>
      <input type="text" class="form-control input-font price inputBox col-md-3" id="manufacturer"
        [(ngModel)]="manufacturer">
      <label for="seller_name" class="toPay col-md-3">Seller Name</label>
      <input type="text" class="form-control input-font price inputBox col-md-3" id="seller_name"
        [(ngModel)]="seller_name">
    </div>
    <div class="col-md-12 mb-2" *ngIf="category !== 'SERVICES'">
      <label for="rack_no" class="toPay col-md-3">Rack No</label>
      <input type="text" class="form-control input-font qty inputBox col-md-3" id="rack_no" [(ngModel)]="rack_no">
      <label for="instructions" class="toPay col-md-3">Instructions</label>
      <input type="text" class="form-control input-font price inputBox col-md-3" id="instructions"
        [(ngModel)]="instructions">
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="col-md-12 text-center">
    <button mat-button class="mat-raised-button mr-4 btn blankTurquoise btnWidth" (click)="dialogRef.close(false)"
      title="Click to cancel the addition of stock to the inventory">Cancel</button>
    <button mat-button class="mat-raised-button btn turquoiseBtn btnWidth btn-sm updateButton" (click)="createItem()"
      title="Click to confirm addition of stock to the inventory">Add</button>
    <!-- <button mat-button class="mat-raised-button btn turquoiseBtn btnWidth btn-sm updateButton"
      (click)="createBatchItem()" *ngIf="batchFlag">Create Batch</button> -->
  </div>
</mat-dialog-actions>
